'use strict';

// Semantic UI Stylesheets
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/list.css');
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/grid.css');
require('ta-semantic-ui/semantic/dist/components/label.css');

// D3
import * as timeformat from 'd3-time-format';
import reqwest from 'reqwest';

//region React Imports
import React from 'react';
require('./Battlestates.css');
//endregion

class Battlestates extends React.Component {

  constructor(state) {
    super(state);

    // Calculate End Date
    let endDate = new Date(Date.now());
    endDate.setMonth(endDate.getMonth() + 1);

    // Set default values – important to have real values, otherwise components
    // down the line will fail to render.
    this.state = {
      ... state,
      error: 'Daten werden geladen ...',
      lastUpdate: "09.09.9999",
      ohioTendency: "Toss Up",
      pennsylvaniaTendency: "Toss Up",
      floridaTendency: "Toss Up",
      michiganTendency: "Toss Up",
      virginiaTendency: "Toss Up",
      northcarolinaTendency: "Toss Up",
      ohioText: "Keine Tendenz",
      pennsylvaniaText: "Keine Tendenz",
      floridaText: "Keine Tendenz",
      michiganText: "Keine Tendenz",
      virginiaText: "Keine Tendenz",
      northcarolinaText: "Keine Tendenz"
    };

  }

  componentDidMount() {


    //region Chart data
    // Load chart data from pollster

    /* So, this is utterly ridiculous. The Pollster API is public, but it
     doesn't support the CORS mechanism (it doesn't provide the
     Access-Control-Allow-Origin: * header). As such, modern browsers will
     complain and not load the data. In order to make it work anyway, I
     have to use JSONP. Fine, why not – but in order to properly work with
     that, I have to load the complete jQuery library. That's 100KB more
     data, just to get that done. So, so very stupid.
     */



    const url = 'http://www.realclearpolitics.com/epolls/json/29_map_w_func.js?callback=return_map&_=1473326300267';

    reqwest(
      {
        url: url,
        type: 'jsonp',
        jsonpCallback: 'callback',
        jsonpCallbackName: 'statesCallback'
      })
      .then((result) => {

        //console.log("######## RESULT ############");
        //console.log(result);
        
        var pollDate = result['election']['module_info']['lastBuildDate'];
        //console.log("pollDate: "+pollDate);
        var d = new Date(pollDate);
        var day = d.getDate();
        if(day < 10) {
          day = "0"+day;
        }
        var month = d.getMonth()+1;
        if(month < 10) {
          month = "0"+month;
        }
        var year = d.getFullYear();
        pollDate = day+"."+month+"."+year;
        //console.log("pollDate: "+pollDate);
        this.setState({lastUpdate: pollDate});

        var thisRef = this;
        result['election']['race'].forEach(function(usState) {
            switch (usState.name) {
                case "Ohio":
                      var tendency = usState.status.toLowerCase();
                      thisRef.setState({ohioTendency: tendency});
                      var tendencyText = translateTendencyText(tendency);
                      thisRef.setState({ohioText: tendencyText});
                    break;
                case "Pennsylvania":
                      var tendency = usState.status.toLowerCase(tendency);
                      thisRef.setState({pennsylvaniaTendency: tendency});
                      var tendencyText = translateTendencyText(tendency);
                      thisRef.setState({pennsylvaniaText: tendencyText});
                    break;
                case "Florida":
                      var tendency = usState.status.toLowerCase(tendency);
                      thisRef.setState({floridaTendency: tendency});
                      var tendencyText = translateTendencyText(tendency);
                      thisRef.setState({floridaText: tendencyText});
                    break;
                case "Michigan":
                      var tendency = usState.status.toLowerCase();
                      thisRef.setState({michiganTendency: tendency});
                      var tendencyText = translateTendencyText(tendency);
                      thisRef.setState({michiganText: tendencyText});
                    break;
                case "Virginia":
                      var tendency = usState.status.toLowerCase(tendency);
                      thisRef.setState({virginiaTendency: tendency});
                      var tendencyText = translateTendencyText(tendency);
                      thisRef.setState({virginiaText: tendencyText});
                    break;
                case "North Carolina":
                      var tendency = usState.status.toLowerCase(tendency);
                      thisRef.setState({northcarolinaTendency: tendency});
                      var tendencyText = translateTendencyText(tendency);
                      thisRef.setState({northcarolinaText: tendencyText});
                    break;
            }
        });


    });
    //endregion
    
  }

  render() {

    return (

      <div className="ui basic vertical infographic">
        <h4 className="ui header">
          Die Tendenz in den Swing States
          <div className="sub header meta">Stand vom {this.state.lastUpdate}
            </div>
        </h4>

        <div className="ui center aligned fluid container">
          <div className="usstate">
            <div className={this.state.ohioTendency}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 123"><polyline className="st0" points="29 23.9 50.6 20.2 60.1 18.4 60.7 19.1 65 19.7 66.8 20.7 69.7 21.3 71.7 22.8 73.9 23.3 75.9 21.3 77.6 23.3 74.6 24 72.4 26 74.6 26.2 76.5 24.4 80.5 24.4 83 25.6 84.9 26 86.7 24.4 89.1 23.6 91.1 22.3 95.3 20.2 97.2 20.7 101.2 20.1 105.1 16.6 107.3 13.4 109.2 11.6 111.2 10 115.1 6.9 127.2 0 127.2 1.2 134.5 42.2 133 43.2 132.1 43.2 131.6 45.1 132.9 46.9 134.3 52.9 133.3 55.1 132.4 61.2 132.9 63.3 132.6 65.9 131.6 66.1 132.1 68 131.6 70 131.7 72.2 131 76.1 128.5 78.4 125.9 82.6 122.2 86 118.6 84.6 116.7 87.2 116.7 89.2 113.8 90.7 112.9 92.7 112.9 94.9 111.6 97 113.3 98.9 112.2 100.9 111.3 103.1 109.2 99.9 107.1 99.2 105.7 101.2 105 103.2 105 105.4 104.4 106.1 103.9 108.3 104.7 109.5 105 113.4 102.8 114.8 102.8 117 101.2 118.9 98.3 120.3 96.3 120.6 96.3 120.5 94.7 118.4 92.7 116.7 90.6 116.6 88.9 114.5 87.3 111.1 84.9 112.2 82.7 114.2 81.7 116.1 79.5 116.1 77.6 117.1 75.7 115.4 73.1 115 71.1 115.1 69.7 117.1 67.8 117.3 63.6 113.9 62.3 113.8 58.4 114.2 56.2 113.8 52.9 109.8 51.7 107.3 47 105.4 43.5 106.4 41.6 105 39 106.6 32.9 53.4 29 23.9 "/></svg>
            </div>
          </div>
          

          <div className="usstate">
            <div className={this.state.pennsylvaniaTendency}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 123"><polyline className="st0" points="0 38.3 3 36.7 7.4 33.1 9.7 30.7 9.8 31.4 17.3 25.3 17.6 26.1 19 34.4 39.6 30.7 71.1 24.4 106.6 16.9 130.2 11.6 130.5 12 132.6 13.1 133.7 15.2 135.6 14.9 138 16.8 140.4 21.4 140.7 23.6 142.7 26 146.7 27.7 148.9 27.9 151.4 29 151.4 29.8 149.1 32.6 148.3 34.7 148.3 36.9 145.7 42.6 143.5 44.8 144.3 46.6 145.3 46.9 146.4 49.1 145.7 51.3 144 53.4 144.6 57 146.5 59.4 148.9 60.2 149.4 62.4 151.4 63.8 152.7 64.3 154.9 66.5 160 70.3 158.7 72.4 156.2 74.8 154.5 77.1 153.8 77.5 153.8 77.6 153.7 77.8 151.9 79.7 151.9 81.9 149.7 83.8 147.6 84.4 145.4 86.8 144.6 86.2 142.9 86 140.7 86.3 138.6 87.6 137.3 89.8 136.7 92 85.7 103 40.7 111.5 13.5 116.4 7.9 84.7 0.2 39.6 0 38.3 "/></svg>
            </div>
          </div>

          <div className="usstate">
            <div className={this.state.floridaTendency}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 123"><polyline className="st0" points="4.7 22 4.2 20.8 4.9 18.7 3.5 17.3 2.2 16.7 0 13.8 0.4 12 1.8 11 19.2 9.2 48.6 5.6 50.6 8.9 50.9 10.1 51.9 11.5 100.2 8 101.7 9 102.8 11.8 104.2 12 105.5 11 105.6 8 105.4 6.6 104.6 5.2 104.4 4 104.8 2.5 105.5 2.5 106.6 1.4 108.1 2 111.7 2.8 113.1 2.9 113.8 2.8 114.4 2.5 116.1 3.1 115.8 6 115 5 115.8 6.5 117.1 7.9 117.8 9.2 118.2 11.8 119.7 14.7 120.1 16.2 122.3 21.2 124.4 25.5 128.9 32.8 136.8 42.8 139.5 45.6 140.4 46.9 141.1 48.4 140 49.8 140.4 52.7 141.2 55.2 141.9 56.6 144.9 60.8 143.4 59.2 140.5 54.8 139.6 50.7 139.9 47.8 139.6 46.2 138.4 45.3 137 45.8 135.5 44.6 135.8 43.2 134.5 42.3 133.9 42.3 134.9 45.2 136.6 49.3 137.4 50.8 141.6 57.4 147 65.2 149.3 70.1 151.1 72.8 151.1 74.2 150.8 74.7 151.2 74.4 152.6 75.1 154.9 77.9 155.2 79.7 155.8 80.1 157.5 85.3 157.7 91.8 158 93.3 158 97.6 158.3 100.3 158.7 102.2 158.5 103.4 158 102.1 157.6 103.4 157.7 104.8 156.6 106.1 156.5 107.4 155.8 108.9 156.1 110.2 155.7 111.1 156.6 113.8 155.7 115.1 155.2 116.6 155.7 117.9 153.9 117.2 154.7 117.9 153.3 117.1 151.9 118.1 150.8 119.4 149.5 119.9 148 119.9 146.6 119.8 144.9 120.9 142 121.8 140.7 120.2 140.1 118.9 141.2 117.6 142.6 118.6 144.3 119.4 145.1 118.1 143.8 117.1 142.3 117.1 141.1 116.6 138.6 113.9 138 112.4 136.2 109.9 134.9 108.9 134.5 107.6 131.8 106.4 130.9 106.3 129.5 106.2 128 106.7 126.6 105.8 128 105.2 126.9 105.2 124.6 102.4 123.1 97.2 121.7 95.9 120.4 95.6 120.3 94.7 121.3 93.3 121.5 91.8 123.1 89.8 121.2 91.3 120.9 92.7 119.6 94.2 118.2 94.2 118.4 93.3 117.7 91.9 117.4 90.6 117.5 87.7 116.6 86.3 118.1 85.3 117.8 85.1 115.2 86.4 114.6 85.4 113.1 85.3 114.4 86.3 115.2 87.7 115.7 89.1 115.1 88.8 113.8 88.8 112.4 88.4 110.2 86.2 109.3 84.8 106.2 79.7 106.5 79.2 105.6 77.8 102.9 76.4 102 75.1 103.3 76.2 103.3 75.2 104.7 74.7 105.1 72.3 107.5 68.2 107.3 66.9 106.1 65.7 104.7 66.9 104.3 65.7 101.3 64.2 101.3 64.3 102.3 65.4 102.3 66.8 102.7 67.2 104 67.2 103.3 69.9 102.4 71.2 102.3 70.8 99.6 68.9 101 71.1 99.6 69.7 98.6 68.2 99.3 65.8 99.3 63.1 98.9 61.8 100.4 54.7 100.5 53.1 100.1 51.7 99.8 47.4 99.6 46.8 99.4 45.3 97.9 44.7 96.9 43.2 96.9 42 94.7 40 91.8 40.2 90.5 39.8 89.7 38.5 88.3 37.8 87.1 36.2 83.1 33.5 82.9 32.2 82.2 30.8 79.3 29.3 77.2 26.5 74.4 24.8 73 24.7 69.9 23 69.1 22.8 67.6 23.2 64.9 23.5 63.6 24.7 62.9 26 63.4 26.7 61.5 26.2 63.3 27 63.8 28.2 62.4 27.8 61.4 28.2 59.9 28.7 55.7 32.2 54.4 32.3 54.1 31.7 52.6 32.8 52.3 33.5 51 33.7 48.2 34.5 47.6 35 46.1 35 44.8 34.5 44.2 33.2 44.4 31.7 44.5 33 45 34.5 46.4 34 46.1 32.8 45.3 31.2 44 30 42.6 29.5 41.1 28.7 41.7 28.7 41.1 28.2 39.8 27.5 38.4 26.2 41.3 27.2 42.7 28.2 43.6 27.2 42.1 27.3 41.3 25.8 39.8 26.2 37.7 24.8 38.4 23.5 39.5 23.2 39.8 21.8 37.6 23.5 36.3 22.8 34.9 23 35.6 24 36.9 25 37.2 26.2 34.4 24.7 30.8 23.5 25.2 22.2 23.8 22.2 22.5 21.8 25.3 22 25.6 21.2 26.9 20.8 28.4 21.5 29.6 21.8 28.9 20.5 26.5 19.5 25 19.8 23.7 20.5 23.3 19.3 20.4 22 19.7 22 16.1 22.5 11.8 23.5 10.3 23.7 10.7 23.5 12.9 22.8 13.9 21.5 12.4 20.2 12.2 18.8 11.6 20.5 10.8 21.8 10.1 19.8 9.3 20.8 9.5 20.8 9.7 21.3 9.1 22.8 7.8 24.8 6.5 25.5 5 26.2 4.2 26 4.9 24.7 6.2 23.2 6.1 22.7 4.7 22 "/></svg>
            </div>
          </div>
        </div>

        <div className="ui center aligned fluid container">
          <div className="usstate">
            <div className={this.state.ohioTendency}>
              <div className="label">Ohio</div>
              <div className="item">
                <i className="circle icon"/><span>{this.state.ohioText}</span>
              </div>
            </div>
          </div>

          <div className="usstate">
            <div className={this.state.pennsylvaniaTendency}>
              <div className="label">Pennsylvania</div>
              <div className="item">
                <i className="circle icon"/><span>{this.state.pennsylvaniaText}</span>
              </div>
            </div>
          </div>

          <div className="usstate">
            <div className={this.state.floridaTendency}>
              <div className="label">Florida</div>
              <div className="item">
                <i className="circle icon"/><span>{this.state.floridaText}</span>
              </div>
            </div>
          </div>
        </div>



        <br />



        <div className="ui center aligned fluid container">
          <div className="usstate">
            <div className={this.state.michiganTendency}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 123"><path className="st0" d="M34 7.7l1.6-1.8 1.9-0.7 4.7-3.4 2-0.5 0.4 0.4 -4.5 4.5 -2.9 1.7 -1.8 0.8L34 7.7zM109.7 35.8l0.5 2.2 2.8 0.2 1.1-1.1c0 0-0.1-1.3-0.4-1.4 -0.3-0.2-1.4-1.7-1.4-1.7l-1.9 0.2 -1.4 0.2 -0.3 1L109.7 35.8zM136.1 91.1l-2.8-7.2 -2-8 -2.1-2.8 -2.3-1.6 -1.4 1 -3.4 1.6 -1.7 4.4 -2.4 3.2 -1 0.5 -1.3-0.5c0 0-2.3-1.3-2.1-1.8 0.2-0.5 0.4-4.4 0.4-4.4l3-1.1 0.7-3 0.5-2.3 2.1-1.4 -0.3-8.8 -1.4-2 -1.1-0.7 -0.7-1.8 0.7-0.7 1.4 0.3 0.2-1.4 -2.3-1.9 -1.1-2.3h-2.3l-3.9-1.3 -4.8-3h-2.4l-0.5 0.5 -0.9-0.4 -2.7-2 -2.5 1.6 -2.5 2 0.3 3.2 0.9 0.3 1.8 0.4 0.4 0.7 -2.3 0.7L92 51.2l-1.3 1.6 -0.3 1.8 0.3 1.4 0.3 4.8 -3.2 1.8 -0.5-0.2v-3.7l1.1-2.1 0.5-2.1 -0.7-0.7 -1.7 0.7 -0.9 3.7 -2.4 1 -1.6 1.7 -0.2 0.9 0.5 0.7 -0.5 2.3 -2 0.4v1l0.7 2.1 -1 5.4 -1.4 3.5 0.5 4.1 0.4 1 -0.7 2.1 -0.3 0.7 -0.3 2.4 3.2 5.3 2.5 5.7 1.3 4.2 -0.7 4.1L83 112l-2.1 4.6 -0.3 2.4 -2.9 2.7 3.9-0.2 18.8-2 6.4-0.9 0.1 1.5 6.1-1.1 9-1.3 3.4-0.4 0.1-0.5 0.2-1.3 1.8-3.2 1.8-1.5 -0.2-4.5 1.4-1.4 1-0.3 0.2-3.2 1.3-2.6 1 0.5 0.2 0.5 0.7 0.2 1.7-0.9L136.1 91.1zM21.7 33.2l0.6-0.5 2.4-0.7 3.2-2v-0.9l0.5-0.5 5.3-0.9 2.1-1.7 3.9-1.8 0.2-1.1 1.7-2.5 1.6-0.7 1.1-1.6 2-2 3.9-2.1 4.1-0.4 1 1 -0.3 0.9 -3.2 0.9 -1.3 2.7 -2 0.7 -0.4 2.1 -2.1 2.8L45.5 27l0.7 0.4 0.9-1 3.2-2.5 1.1 1.1h2l2.8 0.9 1.3 1 1.3 2.7 2.4 2.4 3.4-0.2 1.3-0.9 1.4 1.1 1.4 0.4 1.1-0.7h1l1.4-0.9 3.5-3.2 3-1 5.8-0.3 3.9-1.7 2.3-1.1 1.3 0.2v5l0.4 0.3 2.5 0.7 1.7-0.4 5.4-1.4 1-1 1.3 0.4v6.1l2.8 2.7 1.1 0.5 1.1 0.9 -1.1 0.3 -0.7-0.3 -3.2-0.4 -1.8 0.5 -2-0.2L97.7 39h-1.6L91 37.9 86.4 38l-1.7 2.3 -6.1 0.5 -2.1 0.7 -1 2.7 -1.1 1L74 45l-1.3-1.4 -3.9 2.1h-0.5l-1-1.4 -0.7 0.2 -1.7 3.9L64 51.9 61.2 58l-1.1-0.9 -1.2-0.9 -1.7-9L54.1 46l-1.8-2 -10.6-2.4 -2.5-0.9 -7.2-1.9 -6.9-1L21.7 33.2z"/></svg>
            </div>
          </div>
          

          <div className="usstate">
            <div className={this.state.virginiaTendency}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 123"><path className="st0" d="M152.2 45.9l-0.1-2.3 7.8-3 -1 3.8 -3.5 4.5 -0.5 5.5 0.6 4.1 -2.2 6 -2.6 2.3 -1.8-5.5 0.5-6.5 1.9-5L152.2 45.9zM154.9 79.7L85.4 94.8l-44.7 6.3 -8-0.5 -3.1 2.3 -8.7 0.2 -10 1.2 -10.6 1.2 10.2-5.9v-2.5l1.8-2.5 12.7-13.7 4.7 5.4 4.5 1.2 3-1.3 2.6-1.6 3 1.6 4.7-1.7 2.3-5.5 3.1 0.6 3.5-2.5 2.2 0.6 3.3-4.4 0.4-2.5 -1.2-1.6 1.2-2.3 6.3-14.7 0.7-6.8 1.4-0.6 2.6 2.9 4.7-0.4 2.3-9.1 3.3-0.7 1.2-3.2 3.1-2.7 1.6-2.7 1.8-4.1 0.1-6.1 11.7 4.5c0.8 0.4 0.8-5.7 0.8-5.7l4.9 1.7 -0.6 3.1 9.8 3.5 1.6 2.2 -1.1 4.4 -1.6 1.6 -0.6 2 0.6 2.9 2.4 1.6 4.7 1.7 3.5 1.2 5.9 1.1 2.6 2.5 3.8 0.5 1.1 1.4 -0.5 5.6 1.7 1.3 -0.6 2.3 1.4 1 -0.2 1.7 -3.2-0.1 0.1 1.9 2.7 1.8 0.1 1.7 2.2 2.2 0.6 3 -3.1 1.7 1.9 1.8 6.9-2L154.9 79.7z"/></svg>  
            </div>
          </div>

          <div className="usstate">
            <div className={this.state.northcarolinaTendency}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 123"><path className="st0" d="M146.1 20.5l1.7 4.8 3.7 6.6 2.4 2.4 0.6 2.3 -2.4 0.2 0.8 0.6 -0.3 4.3 -2.6 1.3 -0.6 2.1 -1.3 2.9 -3.8 1.6 -2.4-0.3 -1.5-0.2 -1.6-1.3 0.3 1.3v1h1.9l0.8 1.3 -1.9 6.4h4.3l0.6 1.6 2.3-2.3 1.3-0.5 -1.9 3.7 -3.2 4.9H142l-1.1-0.5 -2.7 0.6 -5.3 2.4 -6.6 5.4 -3.5 4.8 -1.9 6.6 -0.5 2.4 -4.8 0.5 -5.6 1.3 -10.1-8.3L87 72.9l-2.9-0.8 -12.8 1.5 -4.4 0.8 -1.6-3.3L62.2 69l-16.8 0.5L38 70.3l-9.3 4.6 -6.2 2.6 -1.6 0.3 -5.9 1 -7.1 0.8L1 80.2 1.5 76l1.8-1.5 2.7-0.6 0.6-3.8 4.3-2.7 4-1.5 4.3-3.7 4.5-2.1 0.6-3.2 4-4 0.6-0.2c0 0 0 1.1 0.8 1.1 0.8 0 1.9 0.3 1.9 0.3l2.3-3.7 2.1-0.6 2.3 0.3 1.6-3.7 2.9-2.6 0.5-2.1v-4.1l4.6 0.7 7.2-1.3 16.1-1.9 17.4-2.6 20.2-4.1 20-4.3 11.6-2.8L146.1 20.5zM150.1 54.1l2.6-2.5 3.3-2.6 1.5-0.6 0.2-2 -0.6-6.2 -1.5-2.3 -0.6-1.9 0.7-0.2 2.7 5.6 0.4 4.5 -0.2 3.5 -3.5 1.5 -2.8 2.4 -1.1 1.2L150.1 54.1z"/></svg>
            </div>
          </div>
        </div>

        <div className="ui center aligned fluid container">
          <div className="usstate">
            <div className={this.state.michiganTendency}>
              <div className="label">Michigan</div>
              <div className="item">
                <i className="circle icon"/><span>{this.state.michiganText}</span>
              </div>
            </div>
          </div>
          

          <div className="usstate">
            <div className={this.state.virginiaTendency}>
              <div className="label">Virginia</div>
              <div className="item">
                <i className="circle icon"/><span>{this.state.virginiaText}</span>
              </div>
            </div>
          </div>

          <div className="usstate">
            <div className={this.state.northcarolinaTendency}>
              <div className="label">North Carolina</div>
              <div className="item">
                <i className="circle icon"/><span>{this.state.northcarolinaText}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="ui secondary vertical very fitted segment">
          <div className="ui small list">
            <div className="item"><i className="info circle icon"/>
              <div className="content">
                <p>
Die meisten Bundesstaaten wählen entweder stramm demokratisch oder republikanisch – egal welche Kandidaten antreten. Daneben gibt es einige sogenannte Swing States, in denen die Parteiverbundenheit weniger stark ausgeprägt ist. Sie entscheiden über Sieg oder Niederlage bei den Präsidentschaftswahlen. Die wichtigsten Wackelstaaten sind Ohio, Pennsylvania und Florida. Eine Faustregel besagt: Wer mindestens zwei dieser Staaten gewinnt, wird US-Präsident.</p>
                <p>Die Daten stammen ebenfalls von <a
                href="http://www.realclearpolitics.com/epolls/2016/president/2016_elections_electoral_college_map.html"
                target="_blank">Real Clear Politics</a> und basieren auf Umfragen in den Swing States.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default Battlestates;



function translateTendencyText(rawTendency) {

  var tendencyTranslation = "Keine Tendenz";
  var candidateTranslation = "";

  if(rawTendency.indexOf("leaning") !== -1) {
    tendencyTranslation = "Leichte Tendenz ";
  } else if(rawTendency.indexOf("likely") !== -1) {
    tendencyTranslation = "Starke Tendenz ";
  } else if(rawTendency.indexOf("safe") !== -1) {
    tendencyTranslation = "Gilt als sicher für ";
  } else {
    tendencyTranslation = "Keine Tendenz";
  }

  if(rawTendency.indexOf("dem") !== -1) {
    candidateTranslation = "Clinton";
  } else if(rawTendency.indexOf("gop") !== -1) {
    candidateTranslation = "Trump";
  } else {
    candidateTranslation = "";
  }

  return tendencyTranslation+candidateTranslation;
}



/** WEBPACK FOOTER **
 ** ./src/components/battlestates/Battlestates.js
 **/